import { Reveal, ChapterHead } from "./shared";

const STEPS = [
  { title: "Gemstones", text: "Natural gemstone chips in seven colour groups.", testid: "craft-step-gemstones" },
  { title: "Individual stone selection", text: "Each chip is chosen for colour, texture and character.", testid: "craft-step-selection" },
  { title: "Hand-wired branches", text: "Stones are attached one by one to flexible wire branches.", testid: "craft-step-wiring" },
  { title: "Tree formation", text: "Branches are shaped and arranged into the tree's natural form.", testid: "craft-step-formation" },
  { title: "Finished decorative piece", text: "Anchored to its wooden-style base, ready for your space.", testid: "craft-step-finished" },
];

export default function Craftsmanship() {
  return (
    <section id="craftsmanship" className="py-20 lg:py-32" data-testid="craftsmanship-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20">
        <div className="lg:col-span-5">
          <ChapterHead number="05" label="Craftsmanship" title="Crafted By Hand" testid="craft" />
          <Reveal delay={0.15}>
            <p className="mt-8 text-base sm:text-lg text-[#1A201C]/70 leading-relaxed" data-testid="craft-text">
              Each tree is assembled by hand, with individual gemstone chips carefully
              attached to flexible wire branches. The arrangement gives every piece its
              own natural character while preserving the distinctive seven-colour design.
            </p>
          </Reveal>

          <Reveal delay={0.25}>
            <div className="mt-10 relative inline-block" data-testid="craft-tree-image-wrap">
              <div className="overflow-hidden rounded-sm border border-[#1B1915]/12 bg-[#F4F0E6]/70 px-6 pt-6">
                <img
                  src="/assets/tree.webp"
                  alt="Finished handcrafted 7 Chakra Gemstone Tree"
                  className="w-full max-w-[300px] object-contain drop-shadow-[0_30px_30px_rgba(13,40,24,0.2)] transition-transform duration-700 ease-out hover:scale-[1.04]"
                  data-testid="craft-tree-image"
                />
              </div>
              <p className="font-hand text-xl text-[#8C7A56]/80 mt-4 text-center">
                no two trees are ever identical
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 flex flex-col justify-center">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08}>
              <div
                className="group flex gap-6 sm:gap-10 py-7 border-b border-[#1B1915]/12 first:border-t hover:bg-white/60 transition-colors duration-400 px-2 sm:px-4"
                data-testid={s.testid}
              >
                <span className="font-serif-display italic text-2xl sm:text-3xl text-[#C6A15B] w-10 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="font-serif-display text-xl sm:text-2xl text-[#1B1915] tracking-tight">
                    {s.title}
                  </h3>
                  <p className="text-sm text-[#1A201C]/60 mt-1.5 leading-relaxed">{s.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
